import { AcceptedFileType } from './types.ts';

export const DEFAULT_MAX_FILES_UPLOAD = 1;
export const MAX_INDIVIDUAL_DOCUMENT_SIZE_MB = 10;
export const MAX_TOTAL_DOCUMENTS_SIZE_MB = 10;

/**
 * Upload status constants
 */
export const UPLOAD_STATUS = {
  NOT_STARTED: 'NOT_STARTED', // File upload not started, doc was not created
  CREATED: 'CREATED', // Firestore doc created, upload not started
  UPLOADING: 'UPLOADING', // File is uploading to the unscanned bucket // Not yet implemented // start if uploadBytesResumable
  UPLOADED: 'UPLOADED', // File uploaded to unscanned bucket
  SCANNING: 'SCANNING', // File is being scanned by the fire storage malware scanner
  SCANNED: 'SCANNED', // File scanned by the fire storage malware scanner // Not yet implemented [start of onFileQuarantined & onFileUploadComplete]
  QUARANTINED: 'QUARANTINED', // File moved to quarantined bucket, & finalised process were completed
  FINALISING: 'FINALISING', // File uploaded in scanned bucket, initial metadata checks passed, & db updates were started
  COMPLETED: 'COMPLETED', // File upload is complete & db updates are complete.
  FAILED: 'FAILED', // General failure, file upload failed, or db updates failed, mostly in error cases
  CANCELLED: 'CANCELLED', // File upload cancelled
} as const;

type StoragePathMapParams = {
  patientId: string;
};

export const STORAGE_PATH_MAP = {
  CANDOR_DOCUMENT_UPLOAD: ({ patientId }) => `patient_documents/${patientId}/candor_uploads`,
  PATIENT_DOCUMENT_UPLOAD: ({ patientId }) => `patient_documents/${patientId}/documents`,
  /**
   * It is currently stored in the same place as the patient documents, but we should move it to a
   * separate place in the future. Other areas of the codebase may need to be updated to support
   * this.
   */
  CONSENT_TO_RELEASE_HEALTH_SUMMARY: ({ patientId }) => `patient_documents/${patientId}/documents`,
} as const satisfies Record<string, (params: StoragePathMapParams) => string>;

export const DEFAULT_ACCEPTED_FILE_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/jpg',
  'image/gif',
] satisfies AcceptedFileType[];
